import { registerWidget, type CellContentProps, type CellEditorProps } from '../registry'
import { InlineEditor } from '../InlineEditor'

/** E9 · email content — link-coloured text (mailto action wired with editing later). */
function EmailContent({ value }: CellContentProps) {
  if (value == null || value === '') {
    return <span className="text-muted-foreground">—</span>
  }
  return <span className="truncate text-primary">{String(value)}</span>
}

/** email editor — inline input typed as email. */
function EmailEditor(props: CellEditorProps) {
  return (
    <InlineEditor
      {...props}
      inputProps={{ type: 'email' }}
      parse={(s) => (s.trim() === '' ? null : s.trim())}
    />
  )
}

registerWidget('email-address', { read: EmailContent, write: EmailEditor, defaultWidth: 240 })
